import { MembershipType } from '../../payWall/paywall.model';
import { Tooltip } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import { useMemo } from 'react';
import { membershipStyles } from '../../themes/commonStyle';


export const PaidFeatureIcon = ({ membership }: { membership: MembershipType }) => {

  const tooltipTitle = useMemo(() => {
    switch (membership) {
      case 'Free': return 'Free Membership feature';
      case 'Novice': return 'Novice Membership feature';
      case 'Pro': return 'Pro Membership feature';
      default: {
        console.error(`Unknown membership type: ${membership}`);
        return '';
      }
    }
  },
    [membership]);

  return (
    <Tooltip title={tooltipTitle} placement='right-start'>
      <PaidIcon sx={{ marginRight: 1, color: membershipStyles[membership].color }} />
    </Tooltip>
  );
}
